<template>
  <div class="bg">
    <div>
      <div style="flex: 1">
        <!-- <div class="title commonColor" ><span v-if="name">{{name}}</span></div> -->
        <div class="content ql-editor">
          <!-- 成为供应商 -->
          <supplier v-if="supplier" />
          <!-- 意见反馈 -->
          <feedback v-if="feedback" />
          <!--用户注册-->
          <regist v-if="regist"/>
          <div v-html="content" v-if="content"></div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import supplier from "./tobeSupplier";
import feedback from "./feedback";
import regist from "../user/regist";
import { intro } from '@/js/api'
export default {
  name: "header-nav",
  components: {
    supplier,
    feedback, regist
  },
  data() {
    return {
      id: '',
      name:null,
      content:null,
      regist: false,
      supplier: false,
      feedback: false,
    };
  },
  created() {
    this.init()
  },
  watch: {
    $route: function(to, old) {
      this.init()
      this.$forceUpdate();
    }
  },
  methods: {
    init(){
      intro({id:this.$route.query.id}).then(res => {
       if (res.success) {
         if(res.result.type && res.result.type == 1){
           if(res.result.route && res.result.route == 'feedback'){
             this.feedback = true
             this.supplier = false
             this.regist = false
           }else if(res.result.route && res.result.route == 'supplier'){
             this.supplier = true
             this.feedback = false
             this.regist = false
           }else if(res.result.route && res.result.route == 'regist'){
             this.regist = true
             this.feedback = false
             this.supplier = false
           }
           this.name = res.result.name
           this.content = null
         }else{
           this.name = res.result.name
           this.content = res.result.content
           this.feedback = false
           this.supplier = false
           this.regist = false
         }
        }
      })
    }
  }
};
</script>
<style scoped>
@import "../../css/quill.bubble.css";
@import "../../css/quill.core.css";
@import "../../css/quill.snow.css";
</style>
<style scoped>
.el-menu-vertical-demo >>> .el-submenu__title {
  border-bottom: solid 1px #f5f5f5;
}
.el-menu-vertical-demo >>> .el-menu-item {
  border-bottom: solid 1px #f5f5f5;
}
</style>
<style lang="less" scoped>
.bg {
  overflow: hidden;min-width: 1200px;
  > div {
    margin: 20px auto;
    width: 1060px;
    min-height: calc(100vh - 432px);
    display: flex;
  }
}
.title {
  height: 100px;
  background: url(../../assets/title-bg.png) no-repeat;
  padding-left: 140px;
  line-height: 100px;
  font-size: 42px;
  color: rgb(131,197,136) !important;
  border-bottom: dashed 1px rgb(71,68,67);
}
.content {
  padding: 0;
  // text-align: center;
  line-height: 1.5;
  p {
    // text-indent: 14px;
    font-size: 14px;
  }
  // 取消颜色
  // .red {
  //   color: #f56c6c;
  // }
  .bold {
    font-weight: bold;
  }
  h4 {
    padding: 0 4px;
    display: inline-block;
    margin: 20px 0 8px;
    background: #ffd81f;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>
<style scoped>
.content >>> .el-form-item__content{
  width: 420px;
}
.content >>> .el-form-item__label{
  width: 420px;
}
</style>
